/* unplugin-vue-components disabled */import { render } from "./loginChange.vue?vue&type=template&id=48b74671&scoped=true&ts=true"
import script from "./loginChange.vue?vue&type=script&lang=ts"
export * from "./loginChange.vue?vue&type=script&lang=ts"

import "./loginChange.vue?vue&type=style&index=0&id=48b74671&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b74671"]])

export default __exports__